export { Categories as default } from './categories';
